import { BoardVo } from '@/__generated__/CommonApi';
import IcoBook from '@/assets/img/icons/ico_book_white@2x.png';
import IcoDown from '@/assets/img/icons/ico_down_white@2x.png';
import IcoLetter from '@/assets/img/icons/ico_letter_white@2x.png';
import Simg from '@/assets/img/tmp/what-we-do/database_s_img1@2x.jpg';
import Button from '@/components/Button';
import DatabaseLayerPopup from '@/components/Layer/DatabaseLayerPopup';
import { Tit } from '@/components/Titles';
import { breakpoint } from '@/helpers/BreakpointHelper';
import { usePopupStore } from '@/stores/PopupStore';
import { useUserStore } from '@/stores/UserStore';
import { Link, navigate } from 'gatsby';
import { observer } from 'mobx-react-lite';
import React, { useState } from 'react';
import { SubmitHandler } from 'react-hook-form';
import styled from 'styled-components';

import 'swiper/components/navigation/navigation.min.css';
import 'swiper/components/pagination/pagination.min.css';
import 'swiper/components/scrollbar/scrollbar.min.css';

const DatabaseItemContainer = styled.dl`
  display: flex;
  margin: 0 -16px;
  margin-bottom: 64px;
  justify-content: space-between;
  align-items: stretch;

  &:last-child {
    margin-bottom: 0;
  }

  dt {
    width: 304px;
    padding: 0 16px;
    .img-box {
      padding-top: 136.46%;
    }
  }
  dd {
    width: calc(100% - 304px);
    padding: 0 16px;
    max-width: 768px;
    padding-top: 22px;
    position: relative;

    .tag-wrap {
      ${Button} {
        height: 26px;
        line-height: 24px;
        font-size: 14px;
        padding: 0 5px;
        margin-right: 8px;
        margin-bottom: 8px;
        font-weight: normal;
        &:last-child {
          margin-right: 0;
        }
      }
    }
    ${Tit} {
      margin-top: 24px;
      line-height: 1.6;
    }
    .dec {
      margin-top: 8px;
      display: -webkit-box;
      -webkit-line-clamp: 6;
      -webkit-box-orient: vertical;
      overflow: hidden;
      text-overflow: ellipsis;
      height: 192px;
      color: #828385;
      ${breakpoint(640)} {
        font-size: 12px;
      }
    }
    .link-wrap {
      position: absolute;
      left: 0;
      right: 0;
      bottom: 0;
      display: flex;
      max-width: 577px;

      & > li {
        display: inline-block;
        padding: 0 16px;
        width: 33.33%;
        margin-top: 16px;
      }

      ${Button} {
        width: 100%;
        position: relative;

        .txt {
          display: inline-block;
          position: relative;
          padding-left: 29px;

          &::before {
            content: '';
            display: block;
            width: 24px;
            height: 24px;
            background-position: center;
            background-size: cover;
            background-repeat: no-repeat;
            position: absolute;
            left: 0;
            top: 50%;
            transform: translate(0, -50%);
          }
        }
        &.i1 {
          .txt::before {
            background-image: url(${IcoBook});
          }
        }
        &.i2 {
          .txt::before {
            background-image: url(${IcoDown});
          }
        }
        &.i3 {
          .txt::before {
            background-image: url(${IcoLetter});
          }
        }
      }
    }
  }

  ${breakpoint(`tablet`)} {
    margin-bottom: 72px;
    flex-wrap: wrap;

    dt,
    dd {
      width: 100%;
    }
    dt {
      .img-wrap {
        max-width: 200px;
        margin: 0 auto;
      }
    }
    dd {
      margin-top: 24px;

      ${Tit} {
        margin-top: 16px;
      }

      .link-wrap {
        margin: 0 -12px;
        margin-top: 16px;
        position: relative;
        left: auto;
        right: auto;
        max-width: inherit;
        flex-wrap: wrap;

        & > li {
          padding: 0 12px;
        }
      }

      .dec {
        margin-top: 8px;
        -webkit-line-clamp: 3;
        text-overflow: ellipsis;
        height: auto;
      }
    }
  }

  ${breakpoint(`mobile`)} {
    dd {
      .link-wrap {
        flex-wrap: wrap;

        & > li {
          padding: 0 12px;
          width: 50%;
          ${Button} {
            font-size: 14px;
          }
        }
      }
    }
  }
`;

interface categoryProps {
  code: string;
  codeName: string;
}

interface PublicationProps {
  publication: BoardVo;
  categoryList: categoryProps;
  basePath: string;
  queryString: string;
  initialCategory: string;
  onSearch: (value: string) => void;
}
interface SearchFormData {
  category: string;
}

const DatabaseItem: React.FC<PublicationProps> = observer(
  ({
    basePath,
    queryString,
    publication,
    categoryList,
    handleSortKey,
    initialCategory,
    onSearch,
  }) => {
    let image = publication.attGrpNoTn;
    // if (image === undefined || image.indexOf(`null`) !== -1) {

    if (image === undefined) {
      image = Simg;
    }
    const onSubmit: SubmitHandler<SearchFormData> = ({ category }) => {
      onSearch(category);
      return false;
    };

    // 우편신청 팝업
    const userStore = useUserStore();
    const popupStore = usePopupStore();
    const [popupOpen, setPopupOpen] = useState(false);
    const [PopupSid, setPopupSid] = useState<PopupData | string | number>(``);
    const [PopupTitle, setPopupTitle] = useState(``);
    const [PopupCnt, setPopupCnt] = useState(``);

    const isFullText = publication.optData3 === `Y`;

    const getFullUrl = (url: string) => {
      if (!url || url.startsWith(`http://`) || url.startsWith(`https://`)) {
        return url;
      }
      return `${process.env.BACKEND_URL}${url}`;
    };

    return (
      <DatabaseItemContainer>
        <dt>
          <div className="img-wrap">
            <div
              className="img-box"
              css={`
                background-image: url(${publication.imgAttGrpNoTn});
              `}
            />
          </div>
        </dt>
        <dd>
          <nav className="tag-wrap">
            {publication.relCategoryCode !== null && (
              <>
                {publication.relCategoryCode.split(`,`).map((val) => {
                  for (const key in categoryList) {
                    if (val === categoryList[key].code) {
                      return (
                        <Link
                          to={`/what-we-do/database?category=${categoryList[key].code}#tagBox`}
                          key={categoryList[key].code}
                        >
                          <Button
                            outline
                            type="submit"
                            onClick={() => {
                              handleSortKey(categoryList[key].codeName);
                            }}
                          >
                            #{categoryList[key].codeName}
                          </Button>
                          &nbsp;&nbsp;&nbsp;
                        </Link>
                      );
                    }
                  }
                })}
              </>
            )}
          </nav>
          <Tit
            size="s4-1"
            dangerouslySetInnerHTML={{ __html: publication.subject }}
          />
          <p
            className="dec"
            dangerouslySetInnerHTML={{ __html: publication.contents }}
          />
          <ul className="link-wrap">
            {isFullText ? (
              publication.referUrl !== null && publication.referUrl !== `` ? (
                <li>
                  <Button
                    size="sm"
                    className="btn-ico i1"
                    onClick={() =>
                      window.open(
                        `${process.env.BACKEND_URL}/unicef/api/fulltext/view/${publication.boardIndexNumber}`,
                      )
                    }
                  >
                    <span className="txt">전문 보기</span>
                  </Button>
                </li>
              ) : null
            ) : publication.referUrl !== null && publication.referUrl !== `` ? (
              <li>
                <Button
                  size="sm"
                  className="btn-ico i1"
                  onClick={() =>
                    window.open(getFullUrl(publication.referUrl))
                  }
                >
                  <span className="txt">eBook</span>
                </Button>
              </li>
            ) : null}
            {!isFullText && publication.arrAttFile.length > 0 ? (
              <li>
                {userStore.isLoggedIn()
                  ? publication.arrAttFile.map((file, index) => (
                      <a href={file.downloadUrl}>
                        <Button
                          to={file.downloadUrl}
                          size="sm"
                          className="btn-ico i2"
                          key={file.downloadUrl}
                        >
                          <span className="txt">다운로드</span>
                        </Button>
                      </a>
                    ))
                  : publication.arrAttFile.map((file) => (
                      <Button
                        size="sm"
                        type="button"
                        className="btn-ico i2"
                        onClick={() => {
                          popupStore.show(`로그인 후에 신청 가능합니다.`, {
                            onConfirm: () =>
                              navigate(
                                `/auth/login?redirectTo=/what-we-do/database`,
                              ),
                          });
                        }}
                      >
                        <span className="txt">다운로드</span>
                      </Button>
                    ))}
              </li>
            ) : (
              ` `
            )}
            {!isFullText && publication.optData1 === `Y` ? (
              <li>
                {userStore.isLoggedIn() ? (
                  <Button
                    onClick={() => {
                      setPopupOpen(true);
                      setPopupSid(publication.boardIndexNumber);
                      setPopupTitle(publication.subject);
                      setPopupCnt(publication.optData2);
                    }}
                    size="sm"
                    className="btn-ico i3"
                  >
                    <span className="txt">우편신청</span>
                  </Button>
                ) : (
                  <Button
                    type="button"
                    onClick={() => {
                      popupStore.show(`로그인 후에 신청 가능합니다.`, {
                        onConfirm: () =>
                          navigate(
                            `/auth/login?redirectTo=/what-we-do/database`,
                          ),
                      });
                    }}
                    size="sm"
                    className="btn-ico i3"
                  >
                    <span className="txt">우편신청</span>
                  </Button>
                )}
              </li>
            ) : (
              ` `
            )}
          </ul>
        </dd>
        {popupOpen && (
          <DatabaseLayerPopup
            isOpen={popupOpen}
            PopSid={PopupSid}
            PopTitle={PopupTitle}
            PopCnt={PopupCnt}
            onRequestClose={() => setPopupOpen(false)}
          />
        )}
      </DatabaseItemContainer>
    );
  },
);

export default DatabaseItem;
